export default __webpack_public_path__ + "static/media/box.37c5ae98.png";